import * as Html from "../util/Html.ts";
export {init}
Html.registerWidget('widget/rotateonclick',{init:init})

function init(o){
  o.css("transform-origin","50% 50%");
  o.css("transition","all 1.2s");
  o.on('click',function(){
    var angle = o.data('angle')||0;
    angle += 360;
    o.data('angle',angle);
    o.css('transform','rotate('+angle+'deg)');  
  });
}